import AssistantButton from './Button';
import AssistantDashboard from './Dashboard';
import { AssistantProvider, useAssistant } from './providers/Provider';
import { enableDebugMode } from './constants';

const AssistantWrapper = ({
  isSelectEventPage,
}: {
  isSelectEventPage: boolean;
}) => {
  const { isAIEnabledForEvent } = useAssistant();

  if (
    (enableDebugMode && isSelectEventPage) ||
    (!isSelectEventPage && isAIEnabledForEvent())
  ) {
    return (
      <>
        <AssistantButton isLargeButton={isSelectEventPage} />
        <AssistantDashboard />
      </>
    );
  }

  return null;
};

const Assistant = ({ isSelectEventPage }: { isSelectEventPage?: boolean }) => {
  return (
    <AssistantProvider>
      <AssistantWrapper isSelectEventPage={isSelectEventPage || false} />
    </AssistantProvider>
  );
};

export default Assistant;
